import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { canManageSiteScopedCommerce, isSitePaused } from "../common/permissions";
import { useAuthContext } from "../Components/AuthContext";

import { SUBDOMAIN } from "../assets/meta/meta";

const PAUSED_LOCKED_MENU_IDS = new Set([
  "seatMap",
  "reservation",
  "groupReservation",
  "ticket",
  "shopping",
  "benefitRule",
  "coupon",
  "voucher",
  "precoupon",
]);

const PAUSED_LOCKED_HEADER_LABELS = new Set([
  "예약/티켓/쇼핑",
  "쿠폰(할인/무료/예약)",
]);

const filterPausedMenuItems = (items) => {
  return items
    .filter((item) => {
      if (item?.id && PAUSED_LOCKED_MENU_IDS.has(item.id)) {
        return false;
      }
      if (item?.isHeader && PAUSED_LOCKED_HEADER_LABELS.has(item.label)) {
        return false;
      }
      return true;
    })
    .map((item) => {
      if (!item?.subItems && !item?.childItems) {
        return item;
      }

      return {
        ...item,
        ...(item.subItems ? { subItems: filterPausedMenuItems(item.subItems) } : {}),
        ...(item.childItems ? { childItems: filterPausedMenuItems(item.childItems) } : {}),
      };
    });
};

const Navdata = () => {
  const navigate = useNavigate();
  const { userInfo: currentUser } = useAuthContext();

  //state data
  const [isDashboard, setIsDashboard] = useState(true);
  //custom_dw
  const [isReservation, setIsReservation] = useState(false);
  const [isGroupReservation, setIsGroupReservation] = useState(false);
  const [isTicket, setIsTicket] = useState(false);
  const [isCoupon, setIsCoupon] = useState(false);
  const [isVoucher, setIsVoucher] = useState(false);
  const [isPreCoupon, setIsPreCoupon] = useState(false);
  const [isSupply, setIsSupply] = useState(false);
  const [isShopping, setIsShopping] = useState(false);
  const [isTableOrder, setIsTableOrder] = useState(false);

  const [isUser, setIsUser] = useState(false);
  const [isMember, setIsMember] = useState(false);
  const [isStatistics, setIsStatistics] = useState(false);
  const [isMessaging, setIsMessaging] = useState(false);
  const [isNotice, setIsNotice] = useState(false);

  //state data
  const [isApps, setIsApps] = useState(false);
  const [isAuth, setIsAuth] = useState(false);
  const [isPages, setIsPages] = useState(false);
  const [isBaseUi, setIsBaseUi] = useState(false);
  const [isForms, setIsForms] = useState(false);
  const [isTables, setIsTables] = useState(false);
  const [isCharts, setIsCharts] = useState(false);
  const [isIcons, setIsIcons] = useState(false);
  const [isMaps, setIsMaps] = useState(false);
  const [isMultiLevel, setIsMultiLevel] = useState(false);

  // Apps
  const [isEmail, setEmail] = useState(false);
  const [isSubEmail, setSubEmail] = useState(false);
  const [isEcommerce, setIsEcommerce] = useState(false);
  const [isProjects, setIsProjects] = useState(false);
  const [isTasks, setIsTasks] = useState(false);
  const [isCRM, setIsCRM] = useState(false);
  const [isCrypto, setIsCrypto] = useState(false);
  const [isInvoices, setIsInvoices] = useState(false);
  const [isSupportTickets, setIsSupportTickets] = useState(false);
  const [isNFTMarketplace, setIsNFTMarketplace] = useState(false);

  // Authentication
  const [isSignIn, setIsSignIn] = useState(false);
  const [isSignUp, setIsSignUp] = useState(false);
  const [isPasswordReset, setIsPasswordReset] = useState(false);
  const [isPasswordCreate, setIsPasswordCreate] = useState(false);
  const [isLockScreen, setIsLockScreen] = useState(false);
  const [isLogout, setIsLogout] = useState(false);
  const [isSuccessMessage, setIsSuccessMessage] = useState(false);
  const [isVerification, setIsVerification] = useState(false);
  const [isError, setIsError] = useState(false);

  // Pages
  const [isProfile, setIsProfile] = useState(false);
  const [isLanding, setIsLanding] = useState(false);

  // Charts
  const [isApex, setIsApex] = useState(false);

  // Multi Level
  const [isLevel1, setIsLevel1] = useState(false);
  const [isLevel2, setIsLevel2] = useState(false);

  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id)) document.getElementById(id).classList.remove("show");
      });
    }
  }

  // useEffect(() => {
  //   document.body.classList.remove("twocolumn-panel");
  //   if (iscurrentState !== "Dashboard") {
  //     setIsDashboard(false);
  //   }
  // }, [history, iscurrentState, isDashboard]);

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Apps") {
      setIsApps(false);
    }
    if (iscurrentState !== "Auth") {
      setIsAuth(false);
    }
    if (iscurrentState !== "Pages") {
      setIsPages(false);
    }
    if (iscurrentState !== "BaseUi") {
      setIsBaseUi(false);
    }
    if (iscurrentState !== "Forms") {
      setIsForms(false);
    }
    if (iscurrentState !== "Tables") {
      setIsTables(false);
    }
    if (iscurrentState !== "Charts") {
      setIsCharts(false);
    }
    if (iscurrentState !== "Icons") {
      setIsIcons(false);
    }
    if (iscurrentState !== "Maps") {
      setIsMaps(false);
    }
    if (iscurrentState !== "MuliLevel") {
      setIsMultiLevel(false);
    }
    if (iscurrentState === "Widgets") {
      navigate("/widgets");
      document.body.classList.add("twocolumn-panel");
    }
    if (iscurrentState !== "Landing") {
      setIsLanding(false);
    }
  }, [history, iscurrentState, isDashboard, isApps, isAuth, isPages, isBaseUi, isForms, isTables, isCharts, isIcons, isMaps, isMultiLevel]);

  const menuItems = [
    // {
    //   label: "Menu",
    //   isHeader: true,
    // },
    {
      id: "homePage",
      label: "홈페이지",
      icon: "mdi mdi-home",
      directLink: `https://${SUBDOMAIN}.${window.AMZ_ENV.REACT_APP_DOMAIN}/`,
      target: "_blank",
    },
    {
      label: "Menu",
      isHeader: true,
    }
    // {
    //   id: "dashboard",
    //   label: "Dashboards",
    //   icon: "mdi mdi-speedometer",
    //   link: "/#",
    //   stateVariables: isDashboard,
    //   click: function (e) {
    //     e.preventDefault();
    //     setIsDashboard(!isDashboard);
    //     setIscurrentState("Dashboard");
    //     updateIconSidebar(e);
    //   },
    //   subItems: [],
    // },
  ];

  let dashboardSubItems = [];
  const sitePermission = currentUser?.site_permission;
  const sitePermissionLevel = Number(sitePermission?.permission);
  const isCurrentSitePermission = sitePermission?.subdomain === SUBDOMAIN;
  const currentCapabilities = new Set(Array.isArray(currentUser?.capabilities) ? currentUser.capabilities : []);
  const hasCapability = (capability: string) =>
    Boolean(currentUser?.is_global_admin || currentCapabilities.has(capability));

  // 파트너 예약관리자
  if (currentUser && !currentUser.is_global_admin && sitePermissionLevel === 3 && isCurrentSitePermission) {
    dashboardSubItems = [
      {
        id: "reservation",
        label: "예약",
        link: "/#",
        isChildItem: true,
        click: function (e) {
          e.preventDefault();
          setIsReservation(!isReservation);
        },
        stateVariables: isReservation,
        subItems: [
          { id: 1, label: "일별예약관리(현장)", link: "/daily-reservation-list", parentId: "reservation" },
          { id: 2, label: "자유석 배정", link: "/free-seat-assignment", parentId: "reservation" },
        ],
      },
    ];
  }

  // 쇼핑몰 택배관리자
  if (currentUser && !currentUser.is_global_admin && sitePermissionLevel === 4 && isCurrentSitePermission) {
    dashboardSubItems = [
      {
        id: "shopping",
        label: "쇼핑몰",
        link: "/#",
        isChildItem: true,
        click: function (e) {
          e.preventDefault();
          setIsShopping(!isShopping);
        },
        stateVariables: isShopping,
        subItems: (() => {
          let items = [{ id: 1, label: "배송관리", link: "/shopping-admin", parentId: "shopping" }];
          return items;
        })(),
      },
    ];
  }

  // 관리자
  if (currentUser && hasCapability("crm_dashboard")) {
    dashboardSubItems = [
      {
        id: "crm",
        label: "Dashboard",
        link: "/dashboard-crm",
        icon: "mdi mdi-speedometer",
      },
      ...(hasCapability("marketer")
        ? [
            {
              id: "marketerInfo",
              label: "마케터 정보",
              link: "/marketer-info",
              icon: "mdi mdi-account-tie-outline",
            },
          ]
        : []),
      {
        id: "site",
        label: "매장설정",
        link: "/site-form",
        icon: "mdi mdi-home-city-outline",
      },
      {
        id: "messaging",
        label: "알림&메시지",
        icon: "mdi mdi-message-text-outline",
        link: "/#",
        isChildItem: true,
        click: function (e) {
          e.preventDefault();
          setIsMessaging(!isMessaging);
        },
        stateVariables: isMessaging,
        subItems: [
          { id: 1, label: "통합 발송", link: "/notification-center?tab=send", parentId: "messaging" },
          { id: 2, label: "통합 내역", link: "/notification-center?tab=history", parentId: "messaging" },
          { id: 3, label: "시스템 메시지 설정", link: "/notification-center?tab=system", parentId: "messaging" },
          { id: 4, label: "채널 설정", link: "/notification-center?tab=channels", parentId: "messaging" },
        ],
      },
      {
        id: "users",
        label: "사용자",
        icon: "mdi mdi-account-multiple-outline",
        link: "/user-list",
        isChildItem: true,
        click: function (e) {
          e.preventDefault();
          setIsUser(!isUser);
        },
        stateVariables: isUser,
        subItems: [
          { id: 1, label: "사용자관리", link: "/user-list", parentId: "users" },
          // { id: 2, label: "주문내역", link: "/user-order-total", parentId: "users" },
        ],
      },
      {
        id: "members",
        label: "관리자 멤버",
        icon: "mdi mdi-account-group-outline",
        link: "/#",
        isChildItem: true,
        click: function (e) {
          e.preventDefault();
          setIsMember(!isMember);
        },
        stateVariables: isMember,
        subItems: [
          { id: 1, label: "등록 멤버 목록", link: "/member-list", parentId: "members" },
          { id: 2, label: "초대 목록", link: "/member-invitation-list", parentId: "members" },
          { id: 3, label: "접속 장치 관리", link: "/member-auth-sessions", parentId: "members" },
        ],
      },
      {
        id: "notice",
        label: "공지/배너",
        icon: "mdi mdi-bullhorn-outline",
        link: "/#",
        isChildItem: true,
        click: function (e) {
          e.preventDefault();
          setIsNotice(!isNotice);
        },
        stateVariables: isNotice,
        subItems: [
          { id: 1, label: "공지사항", link: "/notice-list", parentId: "notice" },
          { id: 2, label: "배너", link: "/announce-list", parentId: "notice" },
        ],
      },
      {
        label: "예약/티켓/쇼핑",
        isHeader: true,
      },
      {
        id: "seatMap",
        label: "배치도 관리",
        link: "/seat-map",
        icon: "mdi mdi-floor-plan",
      },
      {
        id: "userOrderTotal",
        label: "전체 주문내역",
        link: "/user-order-total",
        icon: "mdi mdi-file-document-outline",
      },
      {
        id: "reservation",
        label: "예약",
        link: "/#",
        icon: "mdi mdi-calendar-clock",
        isChildItem: true,
        click: function (e) {
          e.preventDefault();
          setIsReservation(!isReservation);
        },
        stateVariables: isReservation,
        subItems: [
          { id: 1, label: "예약상품", link: "/reservation-products", parentId: "reservation" },
          { id: 2, label: "예약관리", link: "/reservation-list", parentId: "reservation" },
          { id: 3, label: "일별예약관리(현장)", link: "/daily-reservation-list", parentId: "reservation" },
          { id: 4, label: "자유석 배정", link: "/free-seat-assignment", parentId: "reservation" },
          { id: 5, label: "예약(선물)관리", link: "/reservation-gift-list", parentId: "reservation" },
          { id: 6, label: "예약현황관리", link: "/reservation-calendar", parentId: "reservation" },
          { id: 7, label: "예약취소관리", link: "/canceled-reservation-list", parentId: "reservation" },
          { id: 8, label: "옵션구매내역", link: "/reservation-option-list", parentId: "reservation" },
          { id: 9, label: "옵션상품", link: "/option-product-list", parentId: "reservation" },
          { id: 10, label: "Private Offer", link: "/private-offers", parentId: "reservation" },
        ],
      },
      {
        id: "groupReservation",
        label: "단체예약",
        link: "/#",
        icon: "mdi mdi-account-multiple-plus-outline",
        isChildItem: true,
        click: function (e) {
          e.preventDefault();
          setIsGroupReservation(!isGroupReservation);
        },
        stateVariables: isGroupReservation,
        subItems: [
          { id: 1, label: "신청 관리", link: "/group-reservation-requests", parentId: "groupReservation" },
          { id: 2, label: "옵션 상품", link: "/group-reservation-option-products", parentId: "groupReservation" },
          { id: 3, label: "대리점 링크", link: "/group-reservation-agency-links", parentId: "groupReservation" },
        ],
      },
      {
        id: "ticket",
        label: "티켓",
        icon: "mdi mdi-ticket-percent",
        link: "/#",
        isChildItem: true,
        click: function (e) {
          e.preventDefault();
          setIsTicket(!isTicket);
        },
        stateVariables: isTicket,
        subItems: [
          { id: 1, label: "티켓상품", link: "/ticket-products", parentId: "ticket" },
          { id: 2, label: "사용자티켓", link: "/ticket-list", parentId: "ticket" },
          { id: 3, label: "사용자티켓(선물)", link: "/ticket-gift-list", parentId: "ticket" },
          { id: 4, label: "취소티켓관리", link: "/canceled-ticket-list", parentId: "ticket" },
        ],
      },
      {
        id: "shopping",
        label: "쇼핑몰",
        icon: "mdi mdi-cart-outline",
        link: "/#",
        isChildItem: true,
        click: function (e) {
          e.preventDefault();
          setIsShopping(!isShopping);
        },
        stateVariables: isShopping,
        subItems: (() => {
          let items = [{ id: 1, label: "상품목록", link: "/shopping-product-list", parentId: "shopping" }];
          if (canManageSiteScopedCommerce(currentUser)) {
            items.push({ id: 4, label: "배송관리", link: "/shopping-admin", parentId: "shopping" });
          }
          return items;
        })(),
      },
      {
        id: "tableOrder",
        label: "현장주문",
        icon: "mdi mdi-silverware-fork-knife",
        link: "/#",
        isChildItem: true,
        click: function (e) {
          e.preventDefault();
          setIsTableOrder(!isTableOrder);
        },
        stateVariables: isTableOrder,
        subItems: [
          { id: 1, label: "카테고리", link: "/table-order/menu-categories", parentId: "tableOrder" },
          { id: 2, label: "메뉴", link: "/table-order/menus", parentId: "tableOrder" },
          { id: 3, label: "테이블 그룹", link: "/table-order/table-groups", parentId: "tableOrder" },
          { id: 4, label: "테이블", link: "/table-order/tables", parentId: "tableOrder" },
          { id: 5, label: "자리관리", link: "/table-order/seat-management", parentId: "tableOrder" },
          { id: 6, label: "캐셔 POS", link: "/table-order/pos", parentId: "tableOrder" },
          { id: 7, label: "주문관리", link: "/table-order/orders", parentId: "tableOrder" },
          { id: 8, label: "주방 런처", link: "/table-order/kitchen-launcher", parentId: "tableOrder" },
        ],
      },
      {
        label: "쿠폰(할인/무료/예약)",
        isHeader: true,
      },
      {
        id: "benefitRule",
        label: "자동 혜택 규칙",
        link: "/benefit-rule-list",
        icon: "mdi mdi-auto-fix",
      },
      {
        id: "coupon",
        label: "할인쿠폰",
        icon: "mdi mdi-ticket-confirmation",
        link: "/#",
        isChildItem: true,
        click: function (e) {
          e.preventDefault();
          setIsCoupon(!isCoupon);
        },
        stateVariables: isCoupon,
        subItems: [
          { id: 1, label: "할인쿠폰목록", link: "/coupon-list", parentId: "coupon" },
          { id: 2, label: "사용자할인쿠폰", link: "/user-coupon-list", parentId: "coupon" },
          { id: 3, label: "제휴-할인쿠폰", link: "/b2b-coupon-list", parentId: "coupon" },

          { id: 4, label: "쿠폰 보내기", link: "/user-send-coupon", parentId: "coupon" },
        ],
      },
      {
        id: "voucher",
        label: "무료쿠폰",
        icon: "mdi mdi-ticket-account",
        link: "/#",
        isChildItem: true,
        click: function (e) {
          e.preventDefault();
          setIsVoucher(!isVoucher);
        },
        stateVariables: isVoucher,
        subItems: [
          { id: 1, label: "무료쿠폰목록", link: "/voucher-list", parentId: "voucher" },
          { id: 2, label: "사용자무료쿠폰", link: "/user-voucher-list", parentId: "voucher" },
          { id: 3, label: "사용자무료쿠폰(선물)", link: "/user-voucher-gift-list", parentId: "voucher" },

          { id: 4, label: "제휴-무료쿠폰", link: "/b2b-voucher-list", parentId: "voucher" },

          { id: 5, label: "무료쿠폰 보내기", link: "/voucher-send-coupon", parentId: "voucher" },
        ],
      },
      {
        id: "precoupon",
        label: "예약권",
        icon: "mdi mdi-ticket-confirmation",
        link: "/#",
        isChildItem: true,
        click: function (e) {
          e.preventDefault();
          setIsPreCoupon(!isPreCoupon);
        },
        stateVariables: isPreCoupon,
        subItems: [
          { id: 1, label: "예약권목록", link: "/precoupon-list", parentId: "precoupon" },
          { id: 2, label: "사용자예약권", link: "/user-precoupon-list", parentId: "precoupon" },
          { id: 3, label: "제휴-예약권", link: "/b2b-precoupon-list", parentId: "precoupon" },

          { id: 4, label: "예약권보내기", link: "/reservation-send-coupon", parentId: "precoupon" },
        ],
      },
      {
        label: "관리",
        isHeader: true,
      },
      {
        id: "statistics",
        label: "통계",
        icon: "mdi mdi-chart-bar",
        link: "/#",
        isChildItem: true,
        click: function (e) {
          e.preventDefault();
          setIsStatistics(!isStatistics);
        },
        stateVariables: isStatistics,
        subItems: (() => {
          return [
            { id: 1, label: "매출통계", link: "/sales-statistics", parentId: "statistics" },
            { id: 2, label: "핵심 지표", link: "/core-metrics", parentId: "statistics" },
            { id: 3, label: "정산", link: "/statistics-adjustment", parentId: "statistics" },
          ];
        })(),
      },
      {
        id: "compliance",
        label: "공문",
        link: "/compliance",
        icon: "mdi mdi-file-document-outline",
      },
      {
        id: "supply",
        label: "발주",
        icon: "mdi mdi-truck-delivery",
        link: "/#",
        isChildItem: true,
        click: function (e) {
          e.preventDefault();
          setIsSupply(!isSupply);
        },
        stateVariables: isSupply,
        subItems: (() => {
          let items = [
            { id: 1, label: "지점 발주목록", link: "/supply-list", parentId: "supply" },
            { id: 2, label: "상품목록", link: "/supply-product-list", parentId: "supply" },
            { id: 3, label: "지점 장바구니", link: "/supply-basket-list", parentId: "supply" },
          ];
          if (hasCapability("site_owner")) {
            items.push({ id: 4, label: "배송관리", link: "/supply-admin", parentId: "supply" });
          }
          return items;
        })(),
      },
    ];
  }

  for (let i = 0; i < dashboardSubItems.length; i++) {
    menuItems.push(dashboardSubItems[i]);
  }

  /* Built-in menu definitions removed because routes are missing.
  const builtin_components_menu = [
    {
      id: "apps",
      label: "Apps",
      icon: "mdi mdi-view-grid-plus-outline",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsApps(!isApps);
        setIscurrentState('Apps');
        updateIconSidebar(e);
      },
      stateVariables: isApps,
      subItems: [
        {
          id: "ecommerce",
          label: "Ecommerce",
          link: "/dashboard",
          parentId: "dashboard",
        },
        {
          id: "crypto",
          label: "Crypto",
          link: "/dashboard-crypto",
          parentId: "dashboard",
        },
        {
          id: "projects",
          label: "Projects",
          link: "/dashboard-projects",
          parentId: "dashboard",
        },
        {
          id: "nft",
          label: "NFT",
          link: "/dashboard-nft",
          parentId: "dashboard",
        },
        {
          id: "calendar",
          label: "Calendar",
          link: "/apps-calendar",
          parentId: "apps",
        },
        {
          id: "chat",
          label: "Chat",
          link: "/apps-chat",
          parentId: "apps",
        },
        {
          id: "mailbox",
          label: "Email",
          link: "/#",
          parentId: "apps",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setEmail(!isEmail);
          },
          stateVariables: isEmail,
          childItems: [
            {
              id: 1,
              label: "Mailbox",
              link: "/apps-mailbox",
              parentId: "apps"
            },
            {
              id: 2,
              label: "Email Templates",
              link: "/#",
              parentId: "apps",
              isChildItem: true,
              stateVariables: isSubEmail,
              click: function (e) {
                e.preventDefault();
                setSubEmail(!isSubEmail);
              },
              childItems: [
                { id: 2, label: "Basic Action", link: "/apps-email-basic", parentId: "apps" },
                { id: 3, label: "Ecommerce Action", link: "/apps-email-ecommerce", parentId: "apps" },
              ],
            },
          ]
        },

        {
          id: "appsprojects",
          label: "Projects",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsProjects(!isProjects);
          },
          parentId: "apps",
          stateVariables: isProjects,
          childItems: [
            { id: 1, label: "List", link: "/apps-projects-list", parentId: "apps", },
            { id: 2, label: "Overview", link: "/apps-projects-overview", parentId: "apps", },
            { id: 3, label: "Create Project", link: "/apps-projects-create", parentId: "apps", },
          ]
        },
        {
          id: "tasks",
          label: "Tasks",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsTasks(!isTasks);
          },
          parentId: "apps",
          stateVariables: isTasks,
          childItems: [
            { id: 1, label: "List View", link: "/apps-tasks-list-view", parentId: "apps", },
            { id: 2, label: "Task Details", link: "/apps-tasks-details", parentId: "apps", },
          ]
        },
        {
          id: "appscrm",
          label: "CRM",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsCRM(!isCRM);
          },
          parentId: "apps",
          stateVariables: isCRM,
          childItems: [
            { id: 1, label: "Contacts", link: "/apps-crm-contacts" },
            { id: 2, label: "Companies", link: "/apps-crm-companies" },
            { id: 3, label: "Deals", link: "/apps-crm-deals" },
            { id: 4, label: "Leads", link: "/apps-crm-leads" },
          ]
        },
        {
          id: "appscrypto",
          label: "Crypto",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsCrypto(!isCrypto);
          },
          parentId: "apps",
          stateVariables: isCrypto,
          childItems: [
            { id: 1, label: "Transactions", link: "/apps-crypto-transactions" },
            { id: 2, label: "Buy & Sell", link: "/apps-crypto-buy-sell" },
            { id: 3, label: "Orders", link: "/apps-crypto-orders" },
            { id: 4, label: "My Wallet", link: "/apps-crypto-wallet" },
            { id: 5, label: "ICO List", link: "/apps-crypto-ico" },
            { id: 6, label: "KYC Application", link: "/apps-crypto-kyc" },
          ]
        },
        {
          id: "invoices",
          label: "Invoices",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsInvoices(!isInvoices);
          },
          parentId: "apps",
          stateVariables: isInvoices,
          childItems: [
            { id: 1, label: "List View", link: "/apps-invoices-list" },
            { id: 2, label: "Details", link: "/apps-invoices-details" },
            { id: 3, label: "Create Invoice", link: "/apps-invoices-create" },
          ]
        },
        {
          id: "supportTickets",
          label: "Support Tickets",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsSupportTickets(!isSupportTickets);
          },
          parentId: "apps",
          stateVariables: isSupportTickets,
          childItems: [
            { id: 1, label: "List View", link: "/apps-tickets-list" },
            { id: 2, label: "Ticket Details", link: "/apps-tickets-details" },
          ]
        },
        {
          id: "NFTMarketplace",
          label: "NFT Marketplace",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsNFTMarketplace(!isNFTMarketplace);
          },
          parentId: "apps",
          stateVariables: isNFTMarketplace,
          childItems: [
            { id: 1, label: "Marketplace", link: "/apps-nft-marketplace" },
            { id: 2, label: "Explore Now", link: "/apps-nft-explore" },
            { id: 3, label: "Live Auction", link: "/apps-nft-auction" },
            { id: 4, label: "Item Details", link: "/apps-nft-item-details" },
            { id: 5, label: "Collections", link: "/apps-nft-collections" },
            { id: 6, label: "Creators", link: "/apps-nft-creators" },
            { id: 7, label: "Ranking", link: "/apps-nft-ranking" },
            { id: 8, label: "Wallet Connect", link: "/apps-nft-wallet" },
            { id: 9, label: "Create NFT", link: "/apps-nft-create" },
          ]
        },
        {
          id: "filemanager",
          label: "File Manager",
          link: "/apps-file-manager",
          parentId: "apps",
          badgeName: "New",
          badgeColor: "danger"
        },
        {
          id: "todo",
          label: "To Do",
          link: "/apps-todo",
          parentId: "apps",
          badgeName: "New",
          badgeColor: "danger"
        },
      ],
    },
    {
      label: "Pages",
      isHeader: true,
    },
    {
      id: "authentication",
      label: "Authentication",
      icon: "mdi mdi-account-circle-outline",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsAuth(!isAuth);
        setIscurrentState('Auth');
        updateIconSidebar(e);
      },
      stateVariables: isAuth,
      subItems: [
        {
          id: "signIn",
          label: "Sign In",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsSignIn(!isSignIn);
          },
          parentId: "authentication",
          stateVariables: isSignIn,
          childItems: [
            { id: 1, label: "Basic", link: "/auth-signin-basic" },
            { id: 2, label: "Cover", link: "/auth-signin-cover" },
          ]
        },
        {
          id: "signUp",
          label: "Sign Up",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsSignUp(!isSignUp);
          },
          parentId: "authentication",
          stateVariables: isSignUp,
          childItems: [
            { id: 1, label: "Basic", link: "/auth-signup-basic" },
            { id: 2, label: "Cover", link: "/auth-signup-cover" },
          ]
        },
        {
          id: "passwordReset",
          label: "Password Reset",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsPasswordReset(!isPasswordReset);
          },
          parentId: "authentication",
          stateVariables: isPasswordReset,
          childItems: [
            { id: 1, label: "Basic", link: "/auth-pass-reset-basic" },
            { id: 2, label: "Cover", link: "/auth-pass-reset-cover" },
          ]
        },
        {
          id: "passwordCreate",
          label: "Password Create",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsPasswordCreate(!isPasswordCreate);
          },
          parentId: "authentication",
          stateVariables: isPasswordCreate,
          childItems: [
            { id: 1, label: "Basic", link: "/auth-pass-change-basic" },
            { id: 2, label: "Cover", link: "/auth-pass-change-cover" },
          ]
        },
        {
          id: "lockScreen",
          label: "Lock Screen",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsLockScreen(!isLockScreen);
          },
          parentId: "authentication",
          stateVariables: isLockScreen,
          childItems: [
            { id: 1, label: "Basic", link: "/auth-lockscreen-basic" },
            { id: 2, label: "Cover", link: "/auth-lockscreen-cover" },
          ]
        },
        {
          id: "logout",
          label: "Logout",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsLogout(!isLogout);
          },
          parentId: "authentication",
          stateVariables: isLogout,
          childItems: [
            { id: 1, label: "Basic", link: "/auth--basic" },
            { id: 2, label: "Cover", link: "/auth-logout-cover" },
          ]
        },
        {
          id: "successMessage",
          label: "Success Message",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsSuccessMessage(!isSuccessMessage);
          },
          parentId: "authentication",
          stateVariables: isSuccessMessage,
          childItems: [
            { id: 1, label: "Basic", link: "/auth-success-msg-basic" },
            { id: 2, label: "Cover", link: "/auth-success-msg-cover" },
          ]
        },
        {
          id: "twoStepVerification",
          label: "Two Step Verification",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsVerification(!isVerification);
          },
          parentId: "authentication",
          stateVariables: isVerification,
          childItems: [
            { id: 1, label: "Basic", link: "/auth-twostep-basic" },
            { id: 2, label: "Cover", link: "/auth-twostep-cover" },
          ]
        },
        {
          id: "errors",
          label: "Errors",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsError(!isError);
          },
          parentId: "authentication",
          stateVariables: isError,
          childItems: [
            { id: 1, label: "404 Basic", link: "/auth-404-basic" },
            { id: 2, label: "404 Cover", link: "/auth-404-cover" },
            { id: 3, label: "404 Alt", link: "/auth-404-alt" },
            { id: 4, label: "500", link: "/auth-500" },
            { id: 5, label: "Offline Page", link: "/auth-offline" },
          ]
        },
      ],
    },
    {
      id: "pages",
      label: "Pages",
      icon: "mdi mdi-sticker-text-outline",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsPages(!isPages);
        setIscurrentState('Pages');
        updateIconSidebar(e);
      },
      stateVariables: isPages,
      subItems: [
        {
          id: "starter",
          label: "Starter",
          link: "/pages-starter",
          parentId: "pages",
        },
        {
          id: "profile",
          label: "Profile",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsProfile(!isProfile);
          },
          parentId: "pages",
          stateVariables: isProfile,
          childItems: [
            { id: 1, label: "Simple Page", link: "/pages-profile", parentId: "pages" },
            { id: 2, label: "Settings", link: "/pages-profile-settings", parentId: "pages" },
          ]
        },
        { id: "team", label: "Team", link: "/pages-team", parentId: "pages" },
        { id: "timeline", label: "Timeline", link: "/pages-timeline", parentId: "pages" },
        { id: "faqs", label: "FAQs", link: "/pages-faqs", parentId: "pages" },
        { id: "pricing", label: "Pricing", link: "/pages-pricing", parentId: "pages" },
        { id: "gallery", label: "Gallery", link: "/pages-gallery", parentId: "pages" },
        { id: "maintenance", label: "Maintenance", link: "/pages-maintenance", parentId: "pages" },
        { id: "comingSoon", label: "Coming Soon", link: "/pages-coming-soon", parentId: "pages" },
        { id: "sitemap", label: "Sitemap", link: "/pages-sitemap", parentId: "pages" },
        { id: "searchResults", label: "Search Results", link: "/pages-search-results", parentId: "pages" },
      ],
    },
    {
      id: "landing",
      label: "Landing",
      icon: "ri-rocket-line",
      link: "/#",
      stateVariables: isLanding,
      click: function (e) {
        e.preventDefault();
        setIsLanding(!isLanding);
        setIscurrentState('Landing');
        updateIconSidebar(e);
      },
      subItems: [
        { id: "onePage", label: "One Page", link: "/landing", parentId: "landing" },
        { id: "nftLanding", label: "NFT Landing", link: "/nft-landing", parentId: "landing" },
      ],
    },
    {
      label: "Components",
      isHeader: true,
    },
    {
      id: "baseUi",
      label: "Base UI",
      icon: "mdi mdi-cube-outline",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsBaseUi(!isBaseUi);
        setIscurrentState('BaseUi');
        updateIconSidebar(e);
      },
      stateVariables: isBaseUi,
      subItems: [
        { id: "alerts", label: "Alerts", link: "/ui-alerts", parentId: "baseUi" },
        { id: "badges", label: "Badges", link: "/ui-badges", parentId: "baseUi" },
        { id: "buttons", label: "Buttons", link: "/ui-buttons", parentId: "baseUi" },
        { id: "colors", label: "Colors", link: "/ui-colors", parentId: "baseUi" },
        { id: "cards", label: "Cards", link: "/ui-cards", parentId: "baseUi" },
        { id: "carousel", label: "Carousel", link: "/ui-carousel", parentId: "baseUi" },
        { id: "dropdowns", label: "Dropdowns", link: "/ui-dropdowns", parentId: "baseUi" },
        { id: "grid", label: "Grid", link: "/ui-grid", parentId: "baseUi" },
        { id: "images", label: "Images", link: "/ui-images", parentId: "baseUi" },
        { id: "tabs", label: "Tabs", link: "/ui-tabs", parentId: "baseUi" },
        { id: "accordions", label: "Accordion & Collapse", link: "/ui-accordions", parentId: "baseUi" },
        { id: "modals", label: "Modals", link: "/ui-modals", parentId: "baseUi" },
        { id: "offcanvas", label: "Offcanvas", link: "/ui-offcanvas", parentId: "baseUi" },
        { id: "placeholders", label: "Placeholders", link: "/ui-placeholders", parentId: "baseUi" },
        { id: "progress", label: "Progress", link: "/ui-progress", parentId: "baseUi" },
        { id: "notifications", label: "Notifications", link: "/ui-notifications", parentId: "baseUi" },
        { id: "media", label: "Media object", link: "/ui-media", parentId: "baseUi" },
        { id: "embedvideo", label: "Embed Video", link: "/ui-embed-video", parentId: "baseUi" },
        { id: "typography", label: "Typography", link: "/ui-typography", parentId: "baseUi" },
        { id: "lists", label: "Lists", link: "/ui-lists", parentId: "baseUi" },
        { id: "general", label: "General", link: "/ui-general", parentId: "baseUi" },
        { id: "ribbons", label: "Ribbons", link: "/ui-ribbons", parentId: "baseUi" },
        { id: "utilities", label: "Utilities", link: "/ui-utilities", parentId: "baseUi" },
      ],
    },
    {
      id: "widgets",
      label: "Widgets",
      icon: "mdi mdi-puzzle-outline",
      link: "/widgets",
      click: function (e) {
        e.preventDefault();
        setIscurrentState('Widgets');
      }
    },
    {
      id: "forms",
      label: "Forms",
      icon: "mdi mdi-form-select",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsForms(!isForms);
        setIscurrentState('Forms');
        updateIconSidebar(e);
      },
      stateVariables: isForms,
      subItems: [
        { id: "basicelements", label: "Basic Elements", link: "/forms-elements", parentId: "forms" },
        { id: "formselect", label: "Form Select", link: "/forms-select", parentId: "forms" },
        { id: "checkboxsradios", label: "Checkboxs & Radios", link: "/forms-checkboxes-radios", parentId: "forms" },
        { id: "pickers", label: "Pickers", link: "/forms-pickers", parentId: "forms" },
        { id: "inputmasks", label: "Input Masks", link: "/forms-masks", parentId: "forms" },
        { id: "advanced", label: "Advanced", link: "/forms-advanced", parentId: "forms" },
        { id: "rangeslider", label: "Range Slider", link: "/forms-range-sliders", parentId: "forms" },
        { id: "validation", label: "Validation", link: "/forms-validation", parentId: "forms" },
        { id: "wizard", label: "Wizard", link: "/forms-wizard", parentId: "forms" },
        { id: "editors", label: "Editors", link: "/forms-editors", parentId: "forms" },
        { id: "fileuploads", label: "File Uploads", link: "/forms-file-uploads", parentId: "forms" },
        { id: "formlayouts", label: "Form Layouts", link: "/forms-layouts", parentId: "forms" },
        { id: "select2", label: "Select2", link: "/forms-select2", parentId: "forms" },
      ],
    },
    {
      id: "tables",
      label: "Tables",
      icon: "mdi mdi-grid-large",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsTables(!isTables);
        setIscurrentState('Tables');
        updateIconSidebar(e);
      },
      stateVariables: isTables,
      subItems: [
        { id: "basictables", label: "Basic Tables", link: "/tables-basic", parentId: "tables" },
        { id: "gridjs", label: "Grid Js", link: "/tables-gridjs", parentId: "tables" },
        { id: "listjs", label: "List Js", link: "/tables-listjs", parentId: "tables" },
        { id: "datatables", label: "Datatables", link: "/tables-datatables", parentId: "tables" },
      ],
    },
    {
      id: "charts",
      label: "Charts",
      icon: "mdi mdi-chart-donut",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsCharts(!isCharts);
        setIscurrentState('Charts');
        updateIconSidebar(e);
      },
      stateVariables: isCharts,
      subItems: [
        {
          id: "apexcharts",
          label: "Apexcharts",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsApex(!isApex);
          },
          stateVariables: isApex,
          childItems: [
            { id: 1, label: "Line", link: "/charts-apex-line" },
            { id: 2, label: "Area", link: "/charts-apex-area" },
            { id: 3, label: "Column", link: "/charts-apex-column" },
            { id: 4, label: "Bar", link: "/charts-apex-bar" },
            { id: 5, label: "Mixed", link: "/charts-apex-mixed" },
            { id: 6, label: "Timeline", link: "/charts-apex-timeline" },
            { id: 7, label: "Candlstick", link: "/charts-apex-candlestick" },
            { id: 8, label: "Boxplot", link: "/charts-apex-boxplot" },
            { id: 9, label: "Bubble", link: "/charts-apex-bubble" },
            { id: 10, label: "Scatter", link: "/charts-apex-scatter" },
            { id: 11, label: "Heatmap", link: "/charts-apex-heatmap" },
            { id: 12, label: "Treemap", link: "/charts-apex-treemap" },
            { id: 13, label: "Pie", link: "/charts-apex-pie" },
            { id: 14, label: "Radialbar", link: "/charts-apex-radialbar" },
            { id: 15, label: "Radar", link: "/charts-apex-radar" },
            { id: 16, label: "Polar Area", link: "/charts-apex-polar" },
          ]
        },
        { id: "chartjs", label: "Chartjs", link: "/charts-chartjs", parentId: "charts" },
        { id: "echarts", label: "Echarts", link: "/charts-echarts", parentId: "charts" },
        {
          id: "appsprojects",
          label: "Projects",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsProjects(!isProjects);
          },
          parentId: "apps",
          stateVariables: isProjects,
          childItems: [
            { id: 1, label: "List", link: "/apps-projects-list", parentId: "apps", },
            { id: 2, label: "Overview", link: "/apps-projects-overview", parentId: "apps", },
            { id: 3, label: "Create Project", link: "/apps-projects-create", parentId: "apps", },
          ]
        },
        {
          id: "tasks",
          label: "Tasks",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsTasks(!isTasks);
          },
          parentId: "apps",
          stateVariables: isTasks,
          childItems: [
            { id: 1, label: "List View", link: "/apps-tasks-list-view", parentId: "apps", },
            { id: 2, label: "Task Details", link: "/apps-tasks-details", parentId: "apps", },
          ]
        },
        {
          id: "appscrm",
          label: "CRM",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsCRM(!isCRM);
          },
          parentId: "apps",
          stateVariables: isCRM,
          childItems: [
            { id: 1, label: "Contacts", link: "/apps-crm-contacts" },
            { id: 2, label: "Companies", link: "/apps-crm-companies" },
            { id: 3, label: "Deals", link: "/apps-crm-deals" },
            { id: 4, label: "Leads", link: "/apps-crm-leads" },
          ]
        },
        {
          id: "appscrypto",
          label: "Crypto",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsCrypto(!isCrypto);
          },
          parentId: "apps",
          stateVariables: isCrypto,
          childItems: [
            { id: 1, label: "Transactions", link: "/apps-crypto-transactions" },
            { id: 2, label: "Buy & Sell", link: "/apps-crypto-buy-sell" },
            { id: 3, label: "Orders", link: "/apps-crypto-orders" },
            { id: 4, label: "My Wallet", link: "/apps-crypto-wallet" },
            { id: 5, label: "ICO List", link: "/apps-crypto-ico" },
            { id: 6, label: "KYC Application", link: "/apps-crypto-kyc" },
          ]
        },
        {
          id: "invoices",
          label: "Invoices",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsInvoices(!isInvoices);
          },
          parentId: "apps",
          stateVariables: isInvoices,
          childItems: [
            { id: 1, label: "List View", link: "/apps-invoices-list" },
            { id: 2, label: "Details", link: "/apps-invoices-details" },
            { id: 3, label: "Create Invoice", link: "/apps-invoices-create" },
          ]
        },
        {
          id: "supportTickets",
          label: "Support Tickets",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsSupportTickets(!isSupportTickets);
          },
          parentId: "apps",
          stateVariables: isSupportTickets,
          childItems: [
            { id: 1, label: "List View", link: "/apps-tickets-list" },
            { id: 2, label: "Ticket Details", link: "/apps-tickets-details" },
          ]
        },
        {
          id: "NFTMarketplace",
          label: "NFT Marketplace",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsNFTMarketplace(!isNFTMarketplace);
          },
          parentId: "apps",
          stateVariables: isNFTMarketplace,
          childItems: [
            { id: 1, label: "Marketplace", link: "/apps-nft-marketplace" },
            { id: 2, label: "Explore Now", link: "/apps-nft-explore" },
            { id: 3, label: "Live Auction", link: "/apps-nft-auction" },
            { id: 4, label: "Item Details", link: "/apps-nft-item-details" },
            { id: 5, label: "Collections", link: "/apps-nft-collections" },
            { id: 6, label: "Creators", link: "/apps-nft-creators" },
            { id: 7, label: "Ranking", link: "/apps-nft-ranking" },
            { id: 8, label: "Wallet Connect", link: "/apps-nft-wallet" },
            { id: 9, label: "Create NFT", link: "/apps-nft-create" },
          ]
        },
        {
          id: "filemanager",
          label: "File Manager",
          link: "/apps-file-manager",
          parentId: "apps",
          badgeName: "New",
          badgeColor: "danger"
        },
        {
          id: "todo",
          label: "To Do",
          link: "/apps-todo",
          parentId: "apps",
          badgeName: "New",
          badgeColor: "danger"
        },
      ],
    },
    {
      label: "Pages",
      isHeader: true,
    },
    {
      id: "authentication",
      label: "Authentication",
      icon: "mdi mdi-account-circle-outline",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsAuth(!isAuth);
        setIscurrentState('Auth');
        updateIconSidebar(e);
      },
      stateVariables: isAuth,
      subItems: [
        {
          id: "signIn",
          label: "Sign In",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsSignIn(!isSignIn);
          },
          parentId: "authentication",
          stateVariables: isSignIn,
          childItems: [
            { id: 1, label: "Basic", link: "/auth-signin-basic" },
            { id: 2, label: "Cover", link: "/auth-signin-cover" },
          ]
        },
        {
          id: "signUp",
          label: "Sign Up",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsSignUp(!isSignUp);
          },
          parentId: "authentication",
          stateVariables: isSignUp,
          childItems: [
            { id: 1, label: "Basic", link: "/auth-signup-basic" },
            { id: 2, label: "Cover", link: "/auth-signup-cover" },
          ]
        },
        {
          id: "passwordReset",
          label: "Password Reset",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsPasswordReset(!isPasswordReset);
          },
          parentId: "authentication",
          stateVariables: isPasswordReset,
          childItems: [
            { id: 1, label: "Basic", link: "/auth-pass-reset-basic" },
            { id: 2, label: "Cover", link: "/auth-pass-reset-cover" },
          ]
        },
        {
          id: "passwordCreate",
          label: "Password Create",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsPasswordCreate(!isPasswordCreate);
          },
          parentId: "authentication",
          stateVariables: isPasswordCreate,
          childItems: [
            { id: 1, label: "Basic", link: "/auth-pass-change-basic" },
            { id: 2, label: "Cover", link: "/auth-pass-change-cover" },
          ]
        },
        {
          id: "lockScreen",
          label: "Lock Screen",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsLockScreen(!isLockScreen);
          },
          parentId: "authentication",
          stateVariables: isLockScreen,
          childItems: [
            { id: 1, label: "Basic", link: "/auth-lockscreen-basic" },
            { id: 2, label: "Cover", link: "/auth-lockscreen-cover" },
          ]
        },
        {
          id: "logout",
          label: "Logout",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsLogout(!isLogout);
          },
          parentId: "authentication",
          stateVariables: isLogout,
          childItems: [
            { id: 1, label: "Basic", link: "/auth--basic" },
            { id: 2, label: "Cover", link: "/auth-logout-cover" },
          ]
        },
        {
          id: "successMessage",
          label: "Success Message",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsSuccessMessage(!isSuccessMessage);
          },
          parentId: "authentication",
          stateVariables: isSuccessMessage,
          childItems: [
            { id: 1, label: "Basic", link: "/auth-success-msg-basic" },
            { id: 2, label: "Cover", link: "/auth-success-msg-cover" },
          ]
        },
        {
          id: "twoStepVerification",
          label: "Two Step Verification",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsVerification(!isVerification);
          },
          parentId: "authentication",
          stateVariables: isVerification,
          childItems: [
            { id: 1, label: "Basic", link: "/auth-twostep-basic" },
            { id: 2, label: "Cover", link: "/auth-twostep-cover" },
          ]
        },
        {
          id: "errors",
          label: "Errors",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsError(!isError);
          },
          parentId: "authentication",
          stateVariables: isError,
          childItems: [
            { id: 1, label: "404 Basic", link: "/auth-404-basic" },
            { id: 2, label: "404 Cover", link: "/auth-404-cover" },
            { id: 3, label: "404 Alt", link: "/auth-404-alt" },
            { id: 4, label: "500", link: "/auth-500" },
            { id: 5, label: "Offline Page", link: "/auth-offline" },
          ]
        },
      ],
    },
    {
      id: "pages",
      label: "Pages",
      icon: "mdi mdi-sticker-text-outline",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsPages(!isPages);
        setIscurrentState('Pages');
        updateIconSidebar(e);
      },
      stateVariables: isPages,
      subItems: [
        {
          id: "starter",
          label: "Starter",
          link: "/pages-starter",
          parentId: "pages",
        },
        {
          id: "profile",
          label: "Profile",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsProfile(!isProfile);
          },
          parentId: "pages",
          stateVariables: isProfile,
          childItems: [
            { id: 1, label: "Simple Page", link: "/pages-profile", parentId: "pages" },
            { id: 2, label: "Settings", link: "/pages-profile-settings", parentId: "pages" },
          ]
        },
        { id: "team", label: "Team", link: "/pages-team", parentId: "pages" },
        { id: "timeline", label: "Timeline", link: "/pages-timeline", parentId: "pages" },
        { id: "faqs", label: "FAQs", link: "/pages-faqs", parentId: "pages" },
        { id: "pricing", label: "Pricing", link: "/pages-pricing", parentId: "pages" },
        { id: "gallery", label: "Gallery", link: "/pages-gallery", parentId: "pages" },
        { id: "maintenance", label: "Maintenance", link: "/pages-maintenance", parentId: "pages" },
        { id: "comingSoon", label: "Coming Soon", link: "/pages-coming-soon", parentId: "pages" },
        { id: "sitemap", label: "Sitemap", link: "/pages-sitemap", parentId: "pages" },
        { id: "searchResults", label: "Search Results", link: "/pages-search-results", parentId: "pages" },
      ],
    },
    {
      id: "landing",
      label: "Landing",
      icon: "ri-rocket-line",
      link: "/#",
      stateVariables: isLanding,
      click: function (e) {
        e.preventDefault();
        setIsLanding(!isLanding);
        setIscurrentState('Landing');
        updateIconSidebar(e);
      },
      subItems: [
        { id: "onePage", label: "One Page", link: "/landing", parentId: "landing" },
        { id: "nftLanding", label: "NFT Landing", link: "/nft-landing", parentId: "landing" },
      ],
    },
    {
      label: "Components",
      isHeader: true,
    },
    {
      id: "baseUi",
      label: "Base UI",
      icon: "mdi mdi-cube-outline",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsBaseUi(!isBaseUi);
        setIscurrentState('BaseUi');
        updateIconSidebar(e);
      },
      stateVariables: isBaseUi,
      subItems: [
        { id: "alerts", label: "Alerts", link: "/ui-alerts", parentId: "baseUi" },
        { id: "badges", label: "Badges", link: "/ui-badges", parentId: "baseUi" },
        { id: "buttons", label: "Buttons", link: "/ui-buttons", parentId: "baseUi" },
        { id: "colors", label: "Colors", link: "/ui-colors", parentId: "baseUi" },
        { id: "cards", label: "Cards", link: "/ui-cards", parentId: "baseUi" },
        { id: "carousel", label: "Carousel", link: "/ui-carousel", parentId: "baseUi" },
        { id: "dropdowns", label: "Dropdowns", link: "/ui-dropdowns", parentId: "baseUi" },
        { id: "grid", label: "Grid", link: "/ui-grid", parentId: "baseUi" },
        { id: "images", label: "Images", link: "/ui-images", parentId: "baseUi" },
        { id: "tabs", label: "Tabs", link: "/ui-tabs", parentId: "baseUi" },
        { id: "accordions", label: "Accordion & Collapse", link: "/ui-accordions", parentId: "baseUi" },
        { id: "modals", label: "Modals", link: "/ui-modals", parentId: "baseUi" },
        { id: "offcanvas", label: "Offcanvas", link: "/ui-offcanvas", parentId: "baseUi" },
        { id: "placeholders", label: "Placeholders", link: "/ui-placeholders", parentId: "baseUi" },
        { id: "progress", label: "Progress", link: "/ui-progress", parentId: "baseUi" },
        { id: "notifications", label: "Notifications", link: "/ui-notifications", parentId: "baseUi" },
        { id: "media", label: "Media object", link: "/ui-media", parentId: "baseUi" },
        { id: "embedvideo", label: "Embed Video", link: "/ui-embed-video", parentId: "baseUi" },
        { id: "typography", label: "Typography", link: "/ui-typography", parentId: "baseUi" },
        { id: "lists", label: "Lists", link: "/ui-lists", parentId: "baseUi" },
        { id: "general", label: "General", link: "/ui-general", parentId: "baseUi" },
        { id: "ribbons", label: "Ribbons", link: "/ui-ribbons", parentId: "baseUi" },
        { id: "utilities", label: "Utilities", link: "/ui-utilities", parentId: "baseUi" },
      ],
    },
    {
      id: "widgets",
      label: "Widgets",
      icon: "mdi mdi-puzzle-outline",
      link: "/widgets",
      click: function (e) {
        e.preventDefault();
        setIscurrentState('Widgets');
      }
    },
    {
      id: "forms",
      label: "Forms",
      icon: "mdi mdi-form-select",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsForms(!isForms);
        setIscurrentState('Forms');
        updateIconSidebar(e);
      },
      stateVariables: isForms,
      subItems: [
        { id: "basicelements", label: "Basic Elements", link: "/forms-elements", parentId: "forms" },
        { id: "formselect", label: "Form Select", link: "/forms-select", parentId: "forms" },
        { id: "checkboxsradios", label: "Checkboxs & Radios", link: "/forms-checkboxes-radios", parentId: "forms" },
        { id: "pickers", label: "Pickers", link: "/forms-pickers", parentId: "forms" },
        { id: "inputmasks", label: "Input Masks", link: "/forms-masks", parentId: "forms" },
        { id: "advanced", label: "Advanced", link: "/forms-advanced", parentId: "forms" },
        { id: "rangeslider", label: "Range Slider", link: "/forms-range-sliders", parentId: "forms" },
        { id: "validation", label: "Validation", link: "/forms-validation", parentId: "forms" },
        { id: "wizard", label: "Wizard", link: "/forms-wizard", parentId: "forms" },
        { id: "editors", label: "Editors", link: "/forms-editors", parentId: "forms" },
        { id: "fileuploads", label: "File Uploads", link: "/forms-file-uploads", parentId: "forms" },
        { id: "formlayouts", label: "Form Layouts", link: "/forms-layouts", parentId: "forms" },
        { id: "select2", label: "Select2", link: "/forms-select2", parentId: "forms" },
      ],
    },
    {
      id: "tables",
      label: "Tables",
      icon: "mdi mdi-grid-large",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsTables(!isTables);
        setIscurrentState('Tables');
        updateIconSidebar(e);
      },
      stateVariables: isTables,
      subItems: [
        { id: "basictables", label: "Basic Tables", link: "/tables-basic", parentId: "tables" },
        { id: "gridjs", label: "Grid Js", link: "/tables-gridjs", parentId: "tables" },
        { id: "listjs", label: "List Js", link: "/tables-listjs", parentId: "tables" },
        { id: "datatables", label: "Datatables", link: "/tables-datatables", parentId: "tables" },
      ],
    },
    {
      id: "charts",
      label: "Charts",
      icon: "mdi mdi-chart-donut",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsCharts(!isCharts);
        setIscurrentState('Charts');
        updateIconSidebar(e);
      },
      stateVariables: isCharts,
      subItems: [
        {
          id: "apexcharts",
          label: "Apexcharts",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsApex(!isApex);
          },
          stateVariables: isApex,
          childItems: [
            { id: 1, label: "Line", link: "/charts-apex-line" },
            { id: 2, label: "Area", link: "/charts-apex-area" },
            { id: 3, label: "Column", link: "/charts-apex-column" },
            { id: 4, label: "Bar", link: "/charts-apex-bar" },
            { id: 5, label: "Mixed", link: "/charts-apex-mixed" },
            { id: 6, label: "Timeline", link: "/charts-apex-timeline" },
            { id: 7, label: "Candlstick", link: "/charts-apex-candlestick" },
            { id: 8, label: "Boxplot", link: "/charts-apex-boxplot" },
            { id: 9, label: "Bubble", link: "/charts-apex-bubble" },
            { id: 10, label: "Scatter", link: "/charts-apex-scatter" },
            { id: 11, label: "Heatmap", link: "/charts-apex-heatmap" },
            { id: 12, label: "Treemap", link: "/charts-apex-treemap" },
            { id: 13, label: "Pie", link: "/charts-apex-pie" },
            { id: 14, label: "Radialbar", link: "/charts-apex-radialbar" },
            { id: 15, label: "Radar", link: "/charts-apex-radar" },
            { id: 16, label: "Polar Area", link: "/charts-apex-polar" },
          ]
        },
        { id: "chartjs", label: "Chartjs", link: "/charts-chartjs", parentId: "charts" },
        { id: "echarts", label: "Echarts", link: "/charts-echarts", parentId: "charts" },

      ],
    },
    {
      id: "icons",
      label: "Icons",
      icon: "mdi mdi-android-studio",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsIcons(!isIcons);
        setIscurrentState('Icons');
        updateIconSidebar(e);
      },
      stateVariables: isIcons,
      subItems: [
        { id: "remix", label: "Remix", link: "/icons-remix", parentId: "icons" },
        { id: "boxicons", label: "Boxicons", link: "/icons-boxicons", parentId: "icons" },
        { id: "materialdesign", label: "Material Design", link: "/icons-materialdesign", parentId: "icons" },
        { id: "lineawesome", label: "Line Awesome", link: "/icons-lineawesome", parentId: "icons" },
        { id: "feather", label: "Feather", link: "/icons-feather", parentId: "icons" },
        { id: "crypto", label: "Crypto SVG", link: "/icons-crypto", parentId: "icons", badgeName: "New", badgeColor: "danger" },
      ],
    },
    {
      id: "maps",
      label: "Maps",
      icon: "mdi mdi-map-marker-outline",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsMaps(!isMaps);
        setIscurrentState('Maps');
        updateIconSidebar(e);
      },
      stateVariables: isMaps,
      subItems: [
        { id: "google", label: "Google", link: "/maps-google", parentId: "maps" },
        { id: "vector", label: "Vector", link: "/maps-vector", parentId: "maps" },
        { id: "leaflet", label: "Leaflet", link: "/maps-leaflet", parentId: "maps" },
      ],
    },
    {
      id: "multilevel",
      label: "Multi Level",
      icon: "mdi mdi-share-variant-outline",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsMultiLevel(!isMultiLevel);
        setIscurrentState('MuliLevel');
        updateIconSidebar(e);
      },
      stateVariables: isMultiLevel,
      subItems: [
        { id: "level1.1", label: "Level 1.1", link: "/#", parentId: "multilevel" },
        {
          id: "level1.2",
          label: "Level 1.2",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsLevel1(!isLevel1);
          },
          stateVariables: isLevel1,
          childItems: [
            { id: 1, label: "Level 2.1", link: "/#" },
            {
              id: "level2.2",
              label: "Level 2.2",
              link: "/#",
              isChildItem: true,
              click: function (e) {
                e.preventDefault();
                setIsLevel2(!isLevel2);
              },
              stateVariables: isLevel2,
              childItems: [
                { id: 1, label: "Level 3.1", link: "/#" },
                { id: 2, label: "Level 3.2", link: "/#" },
              ]
            },
          ]
        },
      ],
    },
  ];

  if (currentUser?.site_permission && IS_TEST) {
    menuItems.push({
      label: "Built-in Components",
      isHeader: true,
    })

    for (let i = 0; i < builtin_components_menu.length; i++) {
      menuItems.push(builtin_components_menu[i]);
    }
  }
  */

  const visibleMenuItems = isSitePaused(currentUser) ? filterPausedMenuItems(menuItems) : menuItems;

  return <React.Fragment>{visibleMenuItems as unknown as React.ReactNode}</React.Fragment>;
};
export default Navdata;
